import { IStorage, _AbcGridColumn } from '@barthauer/abc/ui-components';

export class ObjectSelectionGroupData {
  dataRows: any[];
  gridColumns: _AbcGridColumn[];
  storage?: Promise<IStorage | undefined>;
  storageKey?: string;
  selectedRowKeys?: any[]

  constructor(obj?: any) {
    this.dataRows = [];
    this.gridColumns = [];

    if (obj) {
      Object.assign(this, obj);
    }
  }
}
